import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    tableContainer: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        justifyContent: 'flex-end'
    },
    radioButton: {
        margin: theme.spacing(1.5),
        transform: "scale(1.5)",
    },
    radioLabel: {
        fontSize: "medium",
    },
    ToggleContainer: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    },
    saveBtnGrp: {
        display: "flex",
        justifyContent: "right",
    },
    headerContainer: {
        display: "flex",
        paddingLeft: theme.spacing(3),
    },
    syncNowBtnGrp:{
        display: "flex",
        justifyContent: "right",
        margin: theme.spacing(1.5),
    },
}));